var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.type,{ref:"fullscreenParent",tag:"component"},[_vm._t("default"),_vm._v(" "),_c('KeydownObserver',{attrs:{"active":_vm.allowShortcut},on:{"keydown":_vm.keydown}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }